<template>
  <v-card flat dense>
    <v-card-title>
      {{ $t('ITEM.EDIT') }} {{ $t('TILES.ITEM') }}
      <v-spacer></v-spacer>
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-card outlined :loading="loading">
            <v-card-text>
              <language-tabs
                ref="languageTabs"
                v-model="tile.translations"
                :errors="errors.get('translations')"
                #default="{ translation, index, language, on, ...other }"
                eager
              >
                <tile-translation-form
                  :value="translation"
                  :language-id="language.id"
                  v-bind="other"
                  v-on="on"
                  @update-prop="
                    clearErrorByName($event, `translations.${index}`)
                  "
                  @valid="setValid(`translations.${index}`, $event)"
                ></tile-translation-form>
              </language-tabs>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <icon-select
            :value="tile.default_icon"
            name="default_icon"
            :rules="defaultIconRules"
            :label="$t('TILES.SELECT_ICON')"
            :error-messages="errors.get('default_icon')"
            :disabled="!!tile.icon"
            clearable
            @input="tile.default_icon = $event ? $event : null"
            @change="errors.clear('default_icon')"
            @update:error="setValid('default_icon', !$event)"
          ></icon-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <autoupload-file-input
            v-model="tile.icon"
            :label="$t('TILES.ICON')"
            :url="`uploads/tiles`"
            :rules="iconRules"
            :error-messages="errors.get('upload_id')"
            :disabled="!!tile.default_icon"
            @input="tile.upload_id = $event"
            @change="errors.clear('upload_id')"
            @update:error="setValid('upload_id', !$event)"
          ></autoupload-file-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-select
            v-model="tile.type_id"
            outlined
            name="type_id"
            item-value="id"
            item-text="name"
            :items="tilesTypes"
            :rules="rules.type_id"
            :label="$t('TILES.SELECT_TILE_TYPE')"
            :error-messages="errors.get('type_id')"
            :disabled="isDisableType"
            @change="changeType"
            @update:error="setValid('type_id', !$event)"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-select
            v-if="!textFieldContentTiles.includes(tile.type_id)"
            v-model="tile.contentable_id"
            outlined
            name="contentable_id"
            item-value="id"
            item-text="name"
            :items="tilesContents"
            :label="$t('TILES.SELECT_CONTENT')"
            :error-messages="errors.get('contentable_id')"
            :disabled="disableContentTypesIds.includes(tile.type_id)"
            @change="errors.clear('contentable_id')"
          ></v-select>
          <v-text-field
            v-else
            v-model="tile.content"
            outlined
            :label="$t('APP_CONTENT.LINK')"
            :error-messages="errors.get('content')"
            @change="errors.clear('content')"
          />
        </v-col>
      </v-row>
      <v-card-actions>
        <v-btn outlined depressed large color="grey" @click="cancel">
          {{ $t('BUTTON.CANCEL') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          large
          depressed
          color="success"
          :disabled="!isValid"
          @click="update"
        >
          {{ $t('BUTTON.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import tile from './mixins/tile';
import AutouploadFileInput from '@/modules/_global/_components/AutouploadFileInput';

export default {
  name: 'TileEdit',

  components: {
    AutouploadFileInput,
    TileTranslationForm: () => import('./TileTranslationForm'),
    IconSelect: () => import('@/modules/_global/_components/icon_select/IconSelect'),
    LanguageTabs: () => import('@/modules/_global/_components/LanguageTabs')
  },

  mixins: [tile],

  props: {
    id: {
      type: Number,
      required: true
    },
    tilesGroupId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      tile: {
        default_icon: null,
        type_id: null,
        icon: null,
        contentable_id: null,
        translations: [],
        content: null
      },
      valid: {
        default_icon: true,
        upload_id: true,
        type_id: true
      }
    };
  },

  computed: {
    currentTile() {
      return this.$store.getters['tile/GET_TILE_BY_ID'](this.id);
    },
    isDisableType() {
      return !!(this.tile.children && this.tile.children.length > 0);
    }
  },

  watch: {
    currentTile: {
      deep: true,
      immediate: true,
      handler: function(tile) {
        this.tile = {
          ...this.tile,
          ...tile
        };
      }
    }
  },

  mounted() {
    this.getTile({ tileId: this.id }).then(({ data }) => {
      this.getContent(data.type_id);
    });
  },

  methods: {
    ...mapActions('tile', [
      'getTile',
      'updateTile',
      'getTilesTypes',
      'getTilesContents'
    ]),
    update() {
      this.updateTile({
        tilesGroupId: this.tilesGroupId,
        tileId: this.id,
        tile: this.tile
      })
        .then(({ data }) => {
          this.$emit('edited', data);
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>
